import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import FlimpStudio from "./FlimpStudio.jsx";
import store from "./redux/store.jsx";
import WebFont from "webfontloader";
import { googleFonts } from "./utils/Utils.jsx";
import * as amplitude from "@amplitude/analytics-browser";
import { track } from "@amplitude/analytics-browser";
//Context Providers
import { UserProvider } from "./context/userContext.jsx";
import { LocalesProvider } from "./context/localesContext.jsx";
import { VersionHistoryProvider } from "./context/versionHistoryContext.jsx";
import { CustomElementsProvider } from "./context/CustomElementsContext.jsx";
import { ToolbarProvider } from "./context/ToolbarContext.jsx";
import { DragAndDropProvider } from "./context/DragAndDropContext.jsx";

if (typeof window !== "undefined") {
  window.global = window;
}

const fontFormats = googleFonts.map((item) => {
  return item.format;
});

class App extends React.Component {

  componentDidMount() {
    amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, {
      defaultTracking: true,
    });
    track("View Responsive Studio");
    
  }
  render() {
    return (
      <UserProvider>
        <Provider store={store}>
          <LocalesProvider>
            <ToolbarProvider>
              <VersionHistoryProvider>
                <CustomElementsProvider>
                  <DragAndDropProvider>
                    <FlimpStudio />
                  </DragAndDropProvider>
                </CustomElementsProvider>
              </VersionHistoryProvider>
            </ToolbarProvider>
          </LocalesProvider>
        </Provider>
      </UserProvider>
    );
  }
}


// ReactDOM.render(<App />, document.getElementById("root"));
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<App />);
